module.exports = __webpack_public_path__ + "static/process-4692ff40ba3c6295f85110f92abf5399.png";